import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
  SettingsLayout,
  UserSettingsAuthProviders,
  UserSettingsFeatureFlags,
  UserSettingsProfileCard,
  UserSettingsIdentityCard,
} from '@backstage/plugin-user-settings';
import { Progress } from '@backstage/core-components';
import { useGuestState } from '../guest';

export const GuestAwareSettingsPage = () => {
  const { isGuest, loading } = useGuestState();

  if (loading) {
    return <Progress />;
  }

  return (
    <SettingsLayout>
      <SettingsLayout.Route path="general" title="General">
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12} md={6}>
            <UserSettingsProfileCard />
          </Grid>
          {!isGuest && (
            <Grid item xs={12} md={6}>
              <UserSettingsIdentityCard />
            </Grid>
          )}
        </Grid>
      </SettingsLayout.Route>
      {!isGuest && (
        <SettingsLayout.Route
          path="auth-providers"
          title="Authentication Providers"
        >
          <UserSettingsAuthProviders />
        </SettingsLayout.Route>
      )}
      {!isGuest && (
        <SettingsLayout.Route path="feature-flags" title="Feature Flags">
          <UserSettingsFeatureFlags />
        </SettingsLayout.Route>
      )}
    </SettingsLayout>
  );
};
